

var _ul = require('../unified-login/ul');

define(['jquery', 'angular', 'squid/index', 'text!./template.html', 'components/xo-ui-components/src/accessibility/ui', './kmliUpsell', 'components/xo-tracking/dist/index', 'components/ul-inline/dist/inject', 'components/xo-device-info/dist/index'], function ($, angular, squid, template, ui) {

    return angular.module('xo-onetouch-upsell.directive', ['squid', 'xolocale', 'tracking', 'xo-device-info']).directive('xoOnetouchUpsell', function () {

        return {
            template: template,
            scope: {
                token: '=',
                onComplete: '=',
                disableCloseButton: '=',
                ignoreBgClicks: '='
            },
            controller: function controller($scope, $rootScope, $state, $element, $timeout, $logger, $KmliUpsell, $LocaleModel, $locale, $CalDataModel, $config, $meta, $DeviceInfo, $stateParams, $AuthModel) {
                $scope.oneTouchFlowName = $stateParams.oneTouchFlowName;
                $scope.modalActive = false;
                $scope.locale = $LocaleModel.instance();
                $scope.disableCloseButton = $scope.disableCloseButton || $DeviceInfo.isDevice();
                $scope.upsellOptInDisplayed = false;
                var ulMeta = $config.ulMeta || {};
                var PAYPAL = window.PAYPAL || {};
                var ulTimeOutValue = 5000;
                var ulTimeoutPromise = null;

                var fptiData = $KmliUpsell.getFPTIAttributes();
                $KmliUpsell.eligible().then(function (eligibility) {
                    if (eligibility && eligibility.interstitial && eligibility.interstitial.color) {
                        $scope.color = eligibility.interstitial.color;
                    }
                });

                function closeInterstitial(params) {
                    $('#wrapper > xo-spinner').attr('style', '');
                    $('body').removeClass('kmliUpsellActive');
                    $element.removeClass('upsellOpen');
                    $scope.onComplete(params);
                }

                function failureHandler(reason) {
                    $logger.info('KMLI_UPSELL_error_' + reason);
                    closeInterstitial();
                }

                var startTimerTS;
                function startTimer(tag) {
                    startTimerTS = Date.now();
                    $logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
                        startTime: startTimerTS
                    });

                    $logger.info('checkout_fpti', {
                        'from': 'Interstitial_Timer',
                        'to': 'prepare_' + tag
                    });

                    ulTimeoutPromise = $timeout(function () {
                        var stop_time = Date.now();
                        var time_taken = stop_time - startTimerTS;
                        $logger.info('checkout_fpti', {
                            'from': 'Interstitial_Timer',
                            'to': 'process_timeout',
                            'int_error_code': 'ULLOGIN_TIMEOUT',
                            'int_error_description': 'ULLOGIN_TIMEOUT',
                            'error_source': 'unifiedloginnodeweb',
                            'error_type': 'soft_decline',
                            'page_load_time': time_taken
                        });
                        failureHandler('timedout');
                        $rootScope.$emit('loaded');
                    }, ulTimeOutValue);
                }

                function stopTimer(tag) {
                    var stopTimerTS = Date.now();
                    var timeTaken = stopTimerTS - startTimerTS;
                    $logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
                        stopTimer: stopTimerTS,
                        page_load_time: timeTaken
                    });

                    $logger.info('checkout_fpti', {
                        'from': 'Interstitial_Timer',
                        'to': 'process_' + tag,
                        'page_load_time': timeTaken
                    });

                    if (ulTimeoutPromise) {
                        $timeout.cancel(ulTimeoutPromise);
                    }
                }

                function logSubmit(data) {
                    var fptiPayload = {
                        'from': fptiData.stateName,
                        'to': 'process' + fptiData.transInfix + 'optin'
                    };
                    if (data && data.errorCode) {
                        angular.extend(fptiPayload, {
                            'int_error_code': data.errorCode,
                            'error_type': 'hard_decline',
                            'error_source': 'unifiedloginnodeweb'
                        });
                    }
                    $logger.info('checkout_fpti', fptiPayload);
                }

                $scope.hideModal = function (event) {
                    if (event) {
                        event.preventDefault();
                    } else if ($scope.ignoreBgClicks) {
                        return;
                    }

                    $logger.info('checkout_fpti', {
                        'from': fptiData.stateName,
                        'to': 'process' + fptiData.transInfix + 'decline',
                        'click_source': 'close_button'
                    });

                    closeInterstitial();
                };

                var ulEventHandlers = {
                    'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                        stopTimer(data.event);
                        $rootScope.$emit('loaded');
                        $('#wrapper > xo-spinner').hide();
                        $('body').addClass('kmliUpsellActive');

                        // CSS transition to open upsell modal and set modal to trap focus after open
                        $timeout(function () {
                            $element.addClass('upsellOpen');
                            $element.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                                $scope.$apply(function () {
                                    $scope.modalActive = true;
                                    // Focus Continue button in iframe
                                    $('#injectedOneTouchInterstitial').focus();

                                    var escHandler = function escHandler(event) {
                                        if (event.keyCode === ui.KEYS.ESC) {
                                            $scope.hideModal();
                                        }
                                    };

                                    // Add handler to iframe document, as events do not propagate past the iframe
                                    $element.find('iframe').contents().on('keydown', escHandler);
                                    $element.on('keydown', escHandler);
                                });
                            });
                        });
                    },
                    'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                        $rootScope.$emit('loading');
                        startTimer(data.event);
                    },
                    'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                        stopTimer(data.event);
                        $rootScope.$emit('loaded');
                        logSubmit();
                        closeInterstitial(data);
                    },
                    'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                        stopTimer(data.event);
                        $rootScope.$emit('loaded');
                        logSubmit({ errorCode: data.event });
                        closeInterstitial(data);
                    },
                    'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                        stopTimer(data.event);
                        logSubmit({ errorCode: data.event });
                        $rootScope.$emit('loaded');
                        closeInterstitial(data);
                    },
                    'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
                        $logger.info('checkout_fpti', {
                            'from': fptiData.stateName,
                            'to': 'process' + fptiData.transInfix + 'decline',
                            'click_source': 'not_now_link'
                        });
                        closeInterstitial(data);
                    }
                };

                function postMessageHandler(response) {
                    $timeout(function () {
                        $logger.info('ul_postmessaged_received', response);
                        var data = response.data || response.error;
                        var eventId = data && data.event;
                        if (eventId) {
                            $logger.debug('KMLI_UPSELL_' + eventId, response);
                            var handler = ulEventHandlers[eventId];
                            if (handler) {
                                handler(data);
                            }
                        }
                    });
                }

                function upsellOptInDisplayed() {
                    return $AuthModel.instance().retrieve().then(function (auth) {
                        if (auth.upsellOptInDisplayed) {
                            $scope.upsellOptInDisplayed = true;
                        }
                    });
                }

                function loadOneTouchUpsell() {
                    // eslint-disable-line no-unused-vars
                    upsellOptInDisplayed().then(function () {
                        // If the optin upsell is already displayed, no need to display again.
                        if ($scope.upsellOptInDisplayed) {
                            $scope.onComplete();
                        } else {
                            $rootScope.$emit('loading');

                            var options = {
                                targetElement: document.getElementById('injectedOneTouchInterstitial'),
                                queryParams: {
                                    'stsRedirectUri': ulMeta.stsReturnUrl,
                                    'country.x': $scope.locale.country,
                                    'locale.x': $scope.locale.getLocaleCode(),
                                    'flowId': $scope.token,
                                    'correlationId': $CalDataModel.getCalCorrId(),
                                    'flowName': $scope.oneTouchFlowName
                                },
                                iframePathname: '/signin/activate-one-touch',
                                onPostMessage: postMessageHandler
                            };

                            angular.extend(options.queryParams, $KmliUpsell.getOptions());

                            if ($config.deploy.isLocal()) {
                                if ($meta.stage) {
                                    options.origin = 'https://' + $meta.stage;
                                } else {
                                    // if no stage url shows up then use any backup url for origin
                                    options.origin = $config.onboarding.url.split('/webapps/')[0];
                                }
                            }

                            if (PAYPAL && PAYPAL.unifiedLogin) {
                                startTimer('initializeUpsell');
                                PAYPAL.unifiedLogin.inject(options);
                            } else {
                                failureHandler('PAYPAL.unifiedLogin_undefined');
                            }
                        }
                    });
                }

                $timeout(function () {
                    $element.addClass('upsellOpen');
                });

                $scope.optinOneTouch = function () {
                    var flowName = 'checkoutInterstitial'; // login interstitial flow
                    var fptiPayload = {
                        stateName: fptiData.stateName,
                        transInfix: 'process' + fptiData.transInfix + 'optin'
                    };
                    var silent = true;
                    return _ul.$ul.optInToOneTouch($scope.token, $locale.country, $locale.getLocaleCode(), silent, fptiPayload, flowName).then(closeInterstitial({ isKmliSet: true }))['catch'](function (err) {
                        closeInterstitial({
                            isKmliSet: false,
                            error: err
                        });
                    });
                };
            }
        };
    });
});

_ul.$ul;


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/onetouch-interstitial/directive.js
// module id = ./components/xo-login-components/src/onetouch-interstitial/directive.js
// module chunks = 1